export const handleEmailClick = () => {
  const recipient = 'jchan@joinsuperpower.social';
  const subject = encodeURIComponent('Superpower Contact- Insert Subject Here');
  const body = encodeURIComponent('');

  // Create the mailto link
  const mailtoLink = `mailto:${recipient}?subject=${subject}&body=${body}`;

  // Open the default email client
  window.open(mailtoLink, '_blank');
};
